import i18next from "i18next";
import React, { useState } from "react";

export const Tabs = ({
  tabs = [],
  onChange,
  className = "",
  activeTab,
  setActiveTab
}) => {


  const handleChange = (index) => {
    setActiveTab(index);
    if (onChange) onChange(index);
  };

  return (
    <div className={`w-full ${className}`}>
      {/* Tabs Header */}
      <div className="flex border-b gap-1  border-gray-200">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => handleChange(tab.id)}
            className={`px-5 py-2 text-sm font-medium transition-all duration-300
              ${
                activeTab === tab.id
                  ? "border-b-2 rounded-t text-white"
                  : "text-white rounded-t bg-slate-400 hover:text-gray-800"
              }`}
            style={
              activeTab === tab.id
                ? { borderColor: "#261759", backgroundColor: "#261759" }
                : {}
            }
          >
            { i18next.language==="ar" ? tab.labelAr : tab.labelEn}
          </button>
        ))}
      </div>

    </div>
  );
};
